<mat-progress-bar *ngIf="loading" mode="indeterminate" color="warn"></mat-progress-bar>
<br>
<form [formGroup]="teamForm" *ngIf="teamForm" class="px-10" (submit)="submit()">
  <div class="row">
      <div class="col-3">
        <div class="row mb-1">
          <!--div class="col-12">
            <label for="formGroupExampleInput"><small>Auftragsbuch (Kunden)</small></label>
            <select class="form-control"  id="customer_id" name="customer_id" formControlName="customer_id" [ngClass]="{ 'is-invalid': submitted && f['customer_id'].errors }">
              <option [ngValue]=null>bitte auswählen</option>
              <option *ngFor="let customer of orderList" [ngValue]="customer.id">{{customer.company}}</option>
            </select>
            <div *ngIf="submitted && f['customer_id'].errors">
              <div *ngIf="f['customer_id'].errors['required']" class="text-red-500">Kunde wird benötigt</div>
            </div>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <label for="formGroupExampleInput"><small>Standort</small></label>
            <select class="form-control"  id="customer_branch_id" name="customer_branch_id" formControlName="customer_branch_id" [ngClass]="{ 'is-invalid': submitted && f['customer_branch_id'].errors }">
              <option [ngValue]=null>bitte auswählen</option>
              <option *ngFor="let customerBranch of customerBranchList" [ngValue]="customerBranch.id">{{customerBranch.title}}</option>
            </select>
            <div *ngIf="submitted && f['customer_branch_id'].errors">
              <div *ngIf="f['customer_branch_id'].errors['required']" class="text-red-500">Standort wird benötigt</div>
            </div>
          </div-->
        </div>
        
      </div>
      <div class="col-12">
  
        <div class="row mb-1">
          <div class="col-2">
            <label for="formGroupExampleInput"><small>Bezeichnung</small></label>
            <input type="text" class="form-control" id="label" name="label" formControlName="label">
          </div>

          <div class="col-2">
            <label for="formGroupExampleInput"><small>Tour Typ <span class="text-danger">*</span></small></label>
            <select class="form-control" id="type" name="type" formControlName="type" required>
              <option value="" disabled selected hidden>Bitte auswählen</option>
              <option value="K">Küchentour - K</option>
              <option value="M">Möbeltour - M</option>
              <option value="S">Sonstiges - S</option>
            </select>
            <div *ngIf="f.type.invalid && (f.type.dirty || f.type.touched || submitted)" class="text-danger small">
              <div *ngIf="f.type.errors?.required">Tour Typ ist erforderlich</div>
            </div>
          </div>
          
          <div class="col-2">
            <label for="formGroupExampleInput"><small>Firma</small></label>
            <select class="form-control" id="company_id" name="company_id" formControlName="company_id">
              <option [ngValue]="null" disabled selected hidden>Bitte auswählen</option>
              <option *ngFor="let company of companyList" [ngValue]="company.id">{{ company.company_name }}</option>
            </select>
          </div>
        
          <div class="col-1">
            <label for="formGroupExampleInput"><small>Identifikation</small></label>
            <input type="text" class="form-control" id="identity" name="identity"  [ngClass]="{ 'is-invalid': submitted && f['identity'].errors }" formControlName="identity">
            <div *ngIf="submitted && f['identity'].errors">
              <div *ngIf="f['identity'].errors['required']" class="text-red-500">Identifikation wird benötigt</div>
            </div>
          </div>
          

          <div class="col-1">
            <mat-label>Farbe</mat-label>
            <ngx-colors ngx-colors-trigger id="color" name="color" formControlName="color"></ngx-colors>
            <!--mat-form-field>
                <input matInput [(ngModel)]="leftColor">
            </mat-form-field-->
          </div>

          <div class="col-1" class="pt-2">
            <mat-checkbox id="deleted_at" name="deleted_at" formControlName="deleted_at">
              inaktiv
            </mat-checkbox>
           
          </div>

          <div class="col-1" class="pt-2">
            <mat-checkbox id="killable" name="killable" formControlName="killable">
              löschbar
            </mat-checkbox>
          </div>



          <div class="col">
            <!--label for="formGroupExampleInput"><small>Typ</small></label>
            <input type="text" class="form-control" id="identity" name="identity"  [ngClass]="{ 'is-invalid': submitted && f['identity'].errors }" formControlName="identity">
            <div *ngIf="submitted && f['identity'].errors">
              <div *ngIf="f['identity'].errors['required']" class="text-red-500">Vorname wird benötigt</div>
            </div-->
          </div>
        </div>

        <div class="row mb-1">
          <div class="col">
              <label for="formGroupExampleInput"><small>Standard-Arbeitszeit bis:</small></label>
              <input type="text" class="form-control" id="default_start" name="default_start" formControlName="default_start">
          </div>

          <div class="col">
            <label for="formGroupExampleInput"><small>Standard-Arbeitszeit bis:</small></label>
            <input type="text" class="form-control" id="default_end" name="default_end" formControlName="default_end">
          </div>

          <div class="col-1">
            <label for="formGroupExampleInput"><small>AZ:</small></label><br>
            <span class="text-lg">8h</span>
          </div>

          <div class="col">
            <label for="formGroupExampleInput"><small>Wochende:</small></label>
            <input type="text" class="form-control" id="weekend" name="weekend" formControlName="weekend">
          </div>

          <div class="col">
            <label for="formGroupExampleInput"><small>Feiertage berücksichtigen Bundesland:</small></label>
            <input type="text" class="form-control" id="holiday_id" name="holiday_id" formControlName="holiday_id">
          </div>

          <div class="col">
            <label for="formGroupExampleInput"><small>Phone</small></label>
            <input type="text" class="form-control" id="phone" name="phone" formControlName="phone">
          </div>
        
        </div>
        <hr>
        <div class="row mb-1">
          <div class="col">
            <label for="formGroupExampleInput"><small><strong>Legacy (Relevant für Import)</strong></small></label>
            <select class="form-control" id="legacy_team_id" name="legacy_team_id" formControlName="legacy_team_id">
              <option value="" disabled selected hidden>Bitte auswählen</option>
              <option *ngFor="let legacy of legacyList" [ngValue]="legacy.id">{{ legacy.name }} {{legacy.id}}</option>
            </select>
          </div>
        </div>
     </div>   
  </div>
<br>
  


  

  <button type="submit" class="btn btn-success">speichern</button>
  <!--button type="button" class="btn btn-success ml-1" (click)="addDummyData()">add dummydata</button-->
</form>

